import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sleepInfo: null, // 用于存储 sleepInfo
    sleepTypeList: [] // 用于存储 sleepTypeList
  },
  mutations: {
    SET_SLEEP_INFO(state, info) {
      state.sleepInfo = info;
    },
    SET_SLEEP_TYPE_LIST(state, list) {
      state.sleepTypeList = list;
    },
    CLEAR_HEALTH_DATA(state) {
      // 添加一个清空数据的 mutation
      state.sleepInfo = null;
      state.sleepTypeList = [];
    }
  },
  getters: {},
  actions: {},
  modules: {}
});
